import axiosIntents from '@/utils/axios-intents'

import i18n from '@/i18n'

const PAYMENT_PLATFORM = 'stripe'

const state = {
    Stripe: null,
    stripe_initialized: null,
}

const getters = {}

const mutations = {
    saveStripe(state, Stripe) {
        state.Stripe = Stripe
        state.stripe_initialized = null
    },
    stripeInitialized(state, promise) {
        state.stripe_initialized = promise
    },
}

const actions = {
    stripeInit({state, commit}, config) {
        if (state.stripe_initialized) {
            return state.stripe_initialized
        } else {
            if (state.Stripe) {
                return Promise.resolve(state.Stripe)
            } if ('Stripe' in window) {
                const Stripe = window.Stripe(
					process.env.VUE_APP_STRIPE_API_KEY, 
					{ locale: 'en' }
				);

                commit('saveStripe', Stripe)
                return Promise.resolve(state.Stripe)
            } else {
                let stripe_initialized = new Promise((resolve, reject) => {
                    let script = document.createElement('script')
                        script.src = 'https://js.stripe.com/v3/'

                        script.onreadystatechange = script.onload = () => {
                            if (!script.readyState || /loaded|complete/.test(script.readyState)) {
                                const Stripe = window.Stripe(
									process.env.VUE_APP_STRIPE_API_KEY, 
									{ locale: 'en' }
								);

                                commit('saveStripe', Stripe)
                                resolve(state.Stripe)
                            }
                        }

                        script.onerror = () => {
                            reject(new Error(i18n.t('error_by_platform_loading', { platform: 'Stripe' })))
                        }

                    document.getElementsByTagName('head')[0].appendChild(script)
                })

                commit('stripeInitialized', stripe_initialized)

                return stripe_initialized
            }
        }
    },



    stripeSetupIntentClientSecret({dispatch}) {
        return dispatch('setupIntentClientSecret', PAYMENT_PLATFORM)
    },

    stripeSavePaymentMethod({dispatch}, payment_method) {
        return dispatch('stripeInit').then(stripe => {
            return dispatch('stripeSetupIntentClientSecret').then(client_secret => {
                return stripe.confirmCardSetup(client_secret, { // https://docs.stripe.com/js/setup_intents/confirm_card_setup
                    payment_method,
                })
            })
        })
    },

    stripeConfirmPayment({dispatch}, { client_secret, payment_method, payment_method_id }) {
        return dispatch('stripeInit').then(stripe => {
            return stripe.confirmCardPayment(client_secret, payment_method_id // https://docs.stripe.com/js/payment_intents/confirm_card_payment
                ? { payment_method: payment_method_id }
                : payment_method
                    ? { payment_method }
                    : {}
            ).then(result => result?.error
                ? Promise.reject(result.error)
                : Promise.resolve(result)
            )
        })
    },
}

export default {
	state,
	getters,
	mutations,
	actions,
}